(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-collection-doors"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.ma-doors');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var grid = root.querySelector('.ma-doors__grid');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.ma-door-card'));
    var facetGroups = Array.prototype.slice.call(root.querySelectorAll('[data-ma-facet-group]'));
    var doorsGroup = root.querySelector('[data-ma-doors-group]');
    var doorsChips = doorsGroup ? Array.prototype.slice.call(doorsGroup.querySelectorAll('[data-ma-doors-chip]')) : [];
    var doorsHelp = doorsGroup ? doorsGroup.querySelector('[data-ma-doors-help]') : null;
    var clearBtn = root.querySelector('[data-ma-doors-clear]');
    var countEl = root.querySelector('[data-ma-doors-count]');
    var emptyFilter = root.querySelector('[data-ma-doors-empty]');

    function cardHasTag(card, tag) {
      var padded = card.getAttribute('data-ma-tags-padded');
      if (padded === null) {
        padded = ' ' + (card.getAttribute('data-ma-tags') || '') + ' ';
        card.setAttribute('data-ma-tags-padded', padded);
      }
      return padded.indexOf(' ' + tag + ' ') !== -1;
    }

    function applyFilters() {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var matches = facetGroups.every(function (group) {
          var prefix = group.getAttribute('data-tag-prefix');
          var selected = Array.prototype.slice.call(group.querySelectorAll('[data-ma-facet-chip][aria-pressed="true"]'));
          if (!selected.length) return true;
          return selected.some(function (chip) {
            return cardHasTag(card, prefix + ':' + chip.getAttribute('data-value'));
          });
        });
        card.classList.toggle('is-hidden', !matches);
        if (matches) visibleCount += 1;
      });

      if (countEl) {
        countEl.textContent = 'Showing ' + visibleCount + ' of ' + cards.length;
      }
      if (emptyFilter) {
        if (visibleCount === 0) {
          emptyFilter.removeAttribute('hidden');
        } else {
          emptyFilter.setAttribute('hidden', '');
        }
      }
    }

    function anyActive() {
      var facetActive = root.querySelector('[data-ma-facet-chip][aria-pressed="true"]');
      var doorsActive = root.querySelector('[data-ma-doors-chip][aria-pressed="true"]');
      return !!(facetActive || doorsActive);
    }

    function updateClearVisibility() {
      if (!clearBtn) return;
      if (anyActive()) {
        clearBtn.removeAttribute('hidden');
      } else {
        clearBtn.setAttribute('hidden', '');
      }
    }

    function setCardHref(card, doorsValue) {
      if (!card.hasAttribute('data-ma-href')) {
        card.setAttribute('data-ma-href', card.getAttribute('href'));
      }
      var base = card.getAttribute('data-ma-href');
      if (doorsValue) {
        var sep = base.indexOf('?') !== -1 ? '&' : '?';
        card.setAttribute('href', base + sep + 'doors=' + doorsValue);
      } else {
        card.setAttribute('href', base);
      }
    }

    facetGroups.forEach(function (group) {
      var multi = group.getAttribute('data-multi') === 'true';
      var chips = Array.prototype.slice.call(group.querySelectorAll('[data-ma-facet-chip]'));
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var pressed = chip.getAttribute('aria-pressed') === 'true';
          if (!multi) {
            chips.forEach(function (c) {
              c.setAttribute('aria-pressed', 'false');
              c.classList.remove('is-active');
            });
          }
          var next = !pressed;
          chip.setAttribute('aria-pressed', next ? 'true' : 'false');
          chip.classList.toggle('is-active', next);
          applyFilters();
          updateClearVisibility();
        });
      });
    });

    doorsChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var pressed = chip.getAttribute('aria-pressed') === 'true';
        doorsChips.forEach(function (c) {
          c.setAttribute('aria-pressed', 'false');
          c.classList.remove('is-active');
        });
        var next = !pressed;
        var value = next ? chip.getAttribute('data-doors-value') : null;
        chip.setAttribute('aria-pressed', next ? 'true' : 'false');
        chip.classList.toggle('is-active', next);
        cards.forEach(function (card) {
          setCardHref(card, value);
        });
        if (doorsHelp) {
          if (next) {
            doorsHelp.removeAttribute('hidden');
          } else {
            doorsHelp.setAttribute('hidden', '');
          }
        }
        updateClearVisibility();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        facetGroups.forEach(function (group) {
          Array.prototype.slice.call(group.querySelectorAll('[data-ma-facet-chip]')).forEach(function (chip) {
            chip.setAttribute('aria-pressed', 'false');
            chip.classList.remove('is-active');
          });
        });
        doorsChips.forEach(function (chip) {
          chip.setAttribute('aria-pressed', 'false');
          chip.classList.remove('is-active');
        });
        cards.forEach(function (card) {
          setCardHref(card, null);
        });
        if (doorsHelp) doorsHelp.setAttribute('hidden', '');
        applyFilters();
        updateClearVisibility();
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ma-gallery-item]'));
    var lightbox = root.querySelector('[data-ma-lightbox]');
    if (!items.length || !lightbox) return;

    var imgEl = lightbox.querySelector('[data-ma-lightbox-img]');
    var capEl = lightbox.querySelector('[data-ma-lightbox-caption]');
    var closeBtn = lightbox.querySelector('[data-ma-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-ma-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-ma-lightbox-next]');
    var current = 0;
    var lastFocused = null;

    function render() {
      var item = items[current];
      var img = item.querySelector('img');
      imgEl.src = item.getAttribute('data-full') || (img ? img.src : '');
      imgEl.alt = img ? img.alt : '';
      var caption = item.getAttribute('data-caption') || '';
      capEl.textContent = caption;
      capEl.hidden = caption === '';
    }

    function open(index) {
      current = index;
      render();
      lastFocused = document.activeElement;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      imgEl.src = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function step(delta) {
      current = (current + delta + items.length) % items.length;
      render();
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () { open(index); });
    });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });
    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  document.querySelectorAll('[data-ma-gallery]').forEach(initGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatMoney(cents) {
    var value = (Number(cents) / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function initGallery(root) {
    var mainItems = Array.prototype.slice.call(root.querySelectorAll('[data-ma-main-item]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ma-thumb]'));
    if (!mainItems.length) return function () {};

    function show(mediaId) {
      mainItems.forEach(function (item) {
        var match = item.getAttribute('data-media-id') === mediaId;
        item.hidden = !match;
        item.classList.toggle('is-active', match);
      });
      thumbs.forEach(function (thumb) {
        var match = thumb.getAttribute('data-media-id') === mediaId;
        thumb.classList.toggle('is-active', match);
        thumb.setAttribute('aria-pressed', match ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(thumb.getAttribute('data-media-id'));
      });
    });

    return show;
  }

  function initConfigurator(root, showMedia) {
    var variantsScript = root.querySelector('[data-ma-variants]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {
      return;
    }

    var widthKey = root.getAttribute('data-width-key') || 'option1';
    var heightKey = root.getAttribute('data-height-key') || 'option2';
    var widthSelect = root.querySelector('[data-ma-role="width"]');
    var heightSelect = root.querySelector('[data-ma-role="height"]');
    var idInput = root.querySelector('[data-ma-variant-id]');
    var priceEl = root.querySelector('[data-ma-price-amount]');
    var submitBtn = root.querySelector('[data-ma-submit]');
    var availabilityMsg = root.querySelector('[data-ma-availability]');
    var configurator = root.querySelector('[data-ma-configurator]');
    var form = root.querySelector('form');
    var summary = root.querySelector('[data-ma-form-summary]');

    function findVariant() {
      if (!widthSelect || !heightSelect) return variants[0] || null;
      var w = widthSelect.value;
      var h = heightSelect.value;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i][widthKey]) === w && String(variants[i][heightKey]) === h) {
          return variants[i];
        }
      }
      return null;
    }

    function updateVariant() {
      var variant = findVariant();

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submitBtn) submitBtn.disabled = true;
        if (availabilityMsg) {
          availabilityMsg.textContent = 'That size combination is not available online. Contact us for a quote.';
          availabilityMsg.hidden = false;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (variant.available === false) {
        if (submitBtn) submitBtn.disabled = true;
        if (availabilityMsg) {
          availabilityMsg.textContent = 'This size is currently unavailable online. Contact us for a quote.';
          availabilityMsg.hidden = false;
        }
      } else {
        if (submitBtn) submitBtn.disabled = false;
        if (availabilityMsg) availabilityMsg.hidden = true;
      }

      if (variant.featured_media && variant.featured_media.id && showMedia) {
        showMedia(String(variant.featured_media.id));
      }
    }

    if (widthSelect) widthSelect.addEventListener('change', updateVariant);
    if (heightSelect) heightSelect.addEventListener('change', updateVariant);
    updateVariant();

    /* ---- Add-ons (native second line item) ---- */
    function currentWidthMm() {
      if (!widthSelect) return null;
      var raw = widthSelect.value || '';
      var match = raw.match(/\d+/);
      if (!match) return null;
      var num = parseInt(match[0], 10);
      return isNaN(num) ? null : num;
    }

    var addonRows = Array.prototype.slice.call(root.querySelectorAll('[data-ma-addon-row]'));
    var addonIncludedRadio = root.querySelector('[data-ma-addon-radio][value=""]');

    function updateAddonVisibility() {
      if (!addonRows.length) return;
      var width = currentWidthMm();

      /* 1. Work out which addon rows are visible for the current width. */
      var visibleRows = [];
      addonRows.forEach(function (row) {
        var min = parseFloat(row.getAttribute('data-ma-addon-min'));
        var max = parseFloat(row.getAttribute('data-ma-addon-max'));
        if (isNaN(min)) min = 0;
        if (isNaN(max)) max = 9999;
        var visible = width === null || (width >= min && width <= max);
        row.classList.toggle('is-hidden', !visible);
        if (visible) visibleRows.push(row);
      });

      /* 2. If the checked option is now hidden (or nothing is checked), pick a
         new one: the built-in included radio if it exists (it is never hidden
         by width), otherwise the first visible addon row. */
      var checkedRadio = root.querySelector('[data-ma-addon-radio]:checked');
      var checkedVisible = false;
      if (checkedRadio) {
        if (checkedRadio === addonIncludedRadio) {
          checkedVisible = true;
        } else {
          var checkedRow = checkedRadio.closest('[data-ma-addon-row]');
          checkedVisible = !!checkedRow && visibleRows.indexOf(checkedRow) !== -1;
        }
      }

      if (!checkedRadio || !checkedVisible) {
        if (addonIncludedRadio) {
          addonIncludedRadio.checked = true;
        } else if (visibleRows.length) {
          var firstRadio = visibleRows[0].querySelector('[data-ma-addon-radio]');
          if (firstRadio) firstRadio.checked = true;
        } else if (checkedRadio) {
          /* 3. Nothing is visible at all: leave nothing checked. */
          checkedRadio.checked = false;
        }
      }
    }

    if (addonRows.length) {
      updateAddonVisibility();
      if (widthSelect) widthSelect.addEventListener('change', updateAddonVisibility);
      if (heightSelect) heightSelect.addEventListener('change', updateAddonVisibility);
    }

    /* ---- Optional extras (independent checkboxes, client-side only) ---- */
    var extraCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-ma-extra-variant]'));

    function collectExtraVariantIds() {
      var ids = [];
      extraCheckboxes.forEach(function (cb) {
        if (!cb.checked) return;
        var raw = (cb.getAttribute('data-ma-extra-variant') || '').trim();
        if (!/^\d+$/.test(raw)) return;
        ids.push(parseInt(raw, 10));
      });
      return ids;
    }

    /* ---- Option-value upcharges (e.g. Chrome frame colour) ---- */
    var upchargeSelects = Array.prototype.slice.call(root.querySelectorAll('[data-ma-upcharge-value]'));
    var upchargeYesRadios = Array.prototype.slice.call(root.querySelectorAll('[data-ma-yes-upcharge-variant]'));

    function collectUpchargeVariantIds() {
      var ids = [];
      upchargeSelects.forEach(function (select) {
        if (select.value !== select.getAttribute('data-ma-upcharge-value')) return;
        var raw = (select.getAttribute('data-ma-upcharge-variant') || '').trim();
        if (!/^\d+$/.test(raw)) return;
        ids.push(parseInt(raw, 10));
      });
      upchargeYesRadios.forEach(function (radio) {
        if (!radio.checked) return;
        var raw = (radio.getAttribute('data-ma-yes-upcharge-variant') || '').trim();
        if (!/^\d+$/.test(raw)) return;
        ids.push(parseInt(raw, 10));
      });
      return ids;
    }

    upchargeSelects.forEach(function (select) {
      var field = select.closest('.ma-field');
      var note = field ? field.querySelector('[data-ma-upcharge-note]') : null;
      if (!note) return;
      function syncNote() {
        note.hidden = select.value !== select.getAttribute('data-ma-upcharge-value');
      }
      select.addEventListener('change', syncNote);
      syncNote();
    });

    /* ---- Swatch groups ---- */
    var swatchGroups = root.querySelectorAll('.ma-field--swatch');
    swatchGroups.forEach(function (group) {
      var holder = group.querySelector('[data-ma-swatch-value-holder]');
      var btns = Array.prototype.slice.call(group.querySelectorAll('[data-ma-swatch-btn]'));
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          if (holder) holder.value = btn.getAttribute('data-ma-swatch-value');
          group.classList.remove('has-error');
          var err = group.querySelector('[data-ma-error-for]');
          if (err) err.textContent = '';
        });
      });
    });

    /* ---- Tooltips ---- */
    var tooltipTriggers = root.querySelectorAll('[data-ma-tooltip-trigger]');
    tooltipTriggers.forEach(function (trigger) {
      var tip = trigger.parentElement.querySelector('[data-ma-tooltip]');
      if (!tip) return;
      trigger.addEventListener('click', function (evt) {
        evt.stopPropagation();
        tip.hidden = !tip.hidden;
      });
    });
    document.addEventListener('click', function () {
      tooltipTriggers.forEach(function (trigger) {
        var tip = trigger.parentElement.querySelector('[data-ma-tooltip]');
        if (tip) tip.hidden = true;
      });
    });

    /* ---- How to measure modal ---- */
    var measureModal = root.querySelector('[data-ma-measure-modal]');
    if (measureModal) {
      var openMeasure = function () {
        measureModal.hidden = false;
        document.body.style.overflow = 'hidden';
        var c = measureModal.querySelector('[data-ma-measure-close]');
        if (c) c.focus();
      };
      var closeMeasure = function () {
        measureModal.hidden = true;
        document.body.style.overflow = '';
      };
      root.querySelectorAll('[data-ma-measure-open]').forEach(function (b) {
        b.addEventListener('click', openMeasure);
      });
      measureModal.querySelectorAll('[data-ma-measure-close]').forEach(function (b) {
        b.addEventListener('click', closeMeasure);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !measureModal.hidden) closeMeasure();
      });
    }

    /* ---- Validation ---- */
    if (!form || !configurator) return;

    var widthMin = parseFloat(root.getAttribute('data-width-min')) || 0;
    var widthMax = parseFloat(root.getAttribute('data-width-max')) || 999999;
    var heightMin = parseFloat(root.getAttribute('data-height-min')) || 0;
    var heightMax = parseFloat(root.getAttribute('data-height-max')) || 999999;

    /* ---- Measurement bands ----
       The selected width/height option defines a band: the customer's
       measurement must fall between the previous option's value (+1) and
       the selected option's value. The lowest band floors at width_min /
       height_min. Both width and height options are parsed by taking the
       first integer out of the option value, exactly like currentWidthMm()
       above, so composite legacy formats (e.g. "2401-2700", "2101X-2400X")
       and "Up to 2700mm (3 doors)" all resolve consistently between the
       band lookup table and the current selection. */
    function parseOptionMm(raw) {
      var match = (raw || '').match(/\d+/);
      if (!match) return null;
      var num = parseInt(match[0], 10);
      return isNaN(num) ? null : num;
    }

    function buildBandValues(select) {
      var out = [];
      if (!select) return out;
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        var num = parseOptionMm(opt.value);
        if (num !== null && out.indexOf(num) === -1) out.push(num);
      });
      out.sort(function (a, b) { return a - b; });
      return out;
    }

    var widthBandValues = buildBandValues(widthSelect);
    var heightBandValues = buildBandValues(heightSelect);

    function computeBand(values, floorMin, overallMax, currentMm) {
      if (currentMm === null || !values.length) return { min: floorMin, max: overallMax };
      var idx = values.indexOf(currentMm);
      if (idx === -1) return { min: floorMin, max: overallMax };
      var max = values[idx];
      var min = idx === 0 ? floorMin : values[idx - 1] + 1;
      return { min: min, max: max };
    }

    function widthBand() {
      return computeBand(widthBandValues, widthMin, widthMax, currentWidthMm());
    }

    function heightBand() {
      var currentHeightMm = heightSelect ? parseOptionMm(heightSelect.value) : null;
      return computeBand(heightBandValues, heightMin, heightMax, currentHeightMm);
    }

    var MEASURE_FIELDS = [
      { name: 'Top Width', axis: 'width' },
      { name: 'Bottom Width', axis: 'width' },
      { name: 'Left Height', axis: 'height' },
      { name: 'Right Height', axis: 'height' }
    ];

    function fieldBand(axis) {
      return axis === 'width' ? widthBand() : heightBand();
    }

    function validateMeasurements() {
      var valid = true;
      var firstInvalid = null;

      MEASURE_FIELDS.forEach(function (field) {
        var input = form.querySelector('[data-ma-measure="' + field.name + '"]');
        if (!input) return;
        var wrapper = input.closest('.ma-field');
        var errorEl = form.querySelector('[data-ma-error-for="' + field.name + '"]');
        var band = fieldBand(field.axis);
        var raw = input.value.trim();
        var message = '';

        if (raw === '') {
          message = 'Enter a measurement between ' + band.min + 'mm and ' + band.max + 'mm.';
        } else {
          var num = Number(raw);
          if (isNaN(num)) {
            message = 'Enter a number in millimetres.';
          } else if (num < band.min || num > band.max) {
            message = 'Enter a measurement between ' + band.min + 'mm and ' + band.max + 'mm.';
          }
        }

        if (message) {
          valid = false;
          input.setAttribute('aria-invalid', 'true');
          if (wrapper) wrapper.classList.add('has-error');
          if (errorEl) errorEl.textContent = message;
          if (!firstInvalid) firstInvalid = input;
        } else {
          input.removeAttribute('aria-invalid');
          if (wrapper) wrapper.classList.remove('has-error');
          if (errorEl) errorEl.textContent = '';
        }
      });

      return { valid: valid, firstInvalid: firstInvalid };
    }

    /* Re-apply live min/max for the axis's band and, only when a field is
       empty or its current value no longer fits the new band, default it to
       the band max. A valid custom measurement the customer already typed
       is never overwritten. */
    function syncMeasureBounds(axis) {
      var band = fieldBand(axis);
      MEASURE_FIELDS.forEach(function (field) {
        if (field.axis !== axis) return;
        var input = form.querySelector('[data-ma-measure="' + field.name + '"]');
        if (!input) return;
        input.setAttribute('min', band.min);
        input.setAttribute('max', band.max);
        var raw = input.value.trim();
        var num = Number(raw);
        if (raw === '' || isNaN(num) || num < band.min || num > band.max) {
          input.value = band.max;
        }
      });
      validateMeasurements();
    }

    var measureInputs = MEASURE_FIELDS.map(function (field) {
      return form.querySelector('[data-ma-measure="' + field.name + '"]');
    }).filter(Boolean);

    if (measureInputs.length) {
      measureInputs.forEach(function (input) {
        input.addEventListener('input', validateMeasurements);
        input.addEventListener('blur', validateMeasurements);
        input.addEventListener('change', validateMeasurements);
      });

      if (widthSelect) widthSelect.addEventListener('change', function () { syncMeasureBounds('width'); });
      if (heightSelect) heightSelect.addEventListener('change', function () { syncMeasureBounds('height'); });

      /* Populate sensible defaults and set the initial live bounds on first load. */
      syncMeasureBounds('width');
      syncMeasureBounds('height');
    }

    function validateRequiredGroups() {
      var valid = true;
      var firstInvalid = null;
      var groups = form.querySelectorAll('[data-ma-required-group]');

      groups.forEach(function (group) {
        var valueEl = group.querySelector('select[data-ma-required], [data-ma-swatch-value-holder]');
        var value = valueEl ? valueEl.value : '';
        var errorEl = group.querySelector('[data-ma-error-for]');

        if (!value) {
          valid = false;
          group.classList.add('has-error');
          if (errorEl) errorEl.textContent = 'Please make a selection.';
          if (!firstInvalid) firstInvalid = valueEl || group;
        } else {
          group.classList.remove('has-error');
          if (errorEl) errorEl.textContent = '';
        }
      });

      return { valid: valid, firstInvalid: firstInvalid };
    }

    function setSubmitBusy(busy) {
      if (submitBtn) submitBtn.disabled = busy;
      var spinner = submitBtn ? submitBtn.querySelector('.loading-overlay__spinner') : null;
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }

    function submitCart(doorVariantId, extraVariantIds) {
      try {
        setSubmitBusy(true);

        var properties = {};
        var propertyInputs = form.querySelectorAll('[name^="properties["]');
        Array.prototype.slice.call(propertyInputs).forEach(function (input) {
          if ((input.type === 'radio' || input.type === 'checkbox') && !input.checked) return;
          var match = input.name.match(/^properties\[(.+)\]$/);
          if (!match) return;
          var value = (input.value || '').trim();
          if (value === '') return;
          properties[match[1]] = value;
        });

        var items = [
          { id: parseInt(doorVariantId, 10), quantity: 1, properties: properties }
        ];
        var seenVariantIds = {};
        (extraVariantIds || []).forEach(function (id) {
          if (seenVariantIds[id]) return;
          seenVariantIds[id] = true;
          items.push({ id: id, quantity: 1 });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error((result.data && (result.data.description || result.data.message)) || 'Could not add to cart.');
            }
            window.location = '/cart';
          })
          .catch(function (err) {
            setSubmitBusy(false);
            if (summary) {
              summary.hidden = false;
              summary.textContent = (err && err.message) || 'Something went wrong adding to cart. Please try again.';
            }
          });
      } catch (err) {
        setSubmitBusy(false);
        if (summary) {
          summary.hidden = false;
          summary.textContent = 'Something went wrong adding to cart. Please try again.';
        }
      }
    }

    configurator.addEventListener('submit', function (evt) {
      var variant = findVariant();
      var measureResult = validateMeasurements();
      var groupResult = validateRequiredGroups();
      var variantOk = variant && variant.available !== false;

      if (!variantOk || !measureResult.valid || !groupResult.valid) {
        evt.preventDefault();
        evt.stopImmediatePropagation();

        if (summary) {
          summary.hidden = false;
          summary.textContent = !variantOk
            ? 'That size is not available online. Contact us for a quote.'
            : 'Please fix the highlighted fields before adding to cart.';
        }

        var target = groupResult.firstInvalid || measureResult.firstInvalid;
        if (target && typeof target.focus === 'function') target.focus();
        return;
      }

      if (summary) summary.hidden = true;

      var addonRadio = form.querySelector('[data-ma-addon-radio]:checked');
      var addonVariantId = addonRadio ? addonRadio.value : '';
      var extraVariantIds = collectExtraVariantIds().concat(collectUpchargeVariantIds());

      if (addonVariantId && /^\d+$/.test(addonVariantId)) {
        extraVariantIds = [parseInt(addonVariantId, 10)].concat(extraVariantIds);
      }

      if (extraVariantIds.length) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        submitCart(variant.id, extraVariantIds);
      }
    }, true);
  }

  function initQuote(root) {
    var modal = root.querySelector('[data-ma-quote-modal]');
    if (!modal) return;
    var openBtns = root.querySelectorAll('[data-ma-quote-open]');
    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var f = modal.querySelector('input, textarea, [data-ma-quote-close]');
      if (f) f.focus();
    }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-ma-quote-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  function init(root) {
    var showMedia = initGallery(root);
    initConfigurator(root, showMedia);
    initQuote(root);
  }

  document.querySelectorAll('[data-ma-product]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-video"] && !Shopify.designMode) return;
  try {
    
  class MaVideoPlayer extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-ma-video-trigger]');
      this.frame = this.querySelector('[data-ma-video-frame]');
      if (!this.trigger || !this.frame) return;
      this.trigger.addEventListener('click', this.play.bind(this));
    }

    play() {
      const id = this.getAttribute('data-video-id');
      if (!id || this.classList.contains('is-playing')) return;

      const title = this.getAttribute('data-video-title') || 'Video';
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      iframe.title = title;
      iframe.className = 'ma-video__iframe';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';

      this.frame.innerHTML = '';
      this.frame.appendChild(iframe);
      this.classList.add('is-playing');
    }
  }

  customElements.define('ma-video-player', MaVideoPlayer);

  } catch(e) { console.error(e); }
})();
})();
